import React, { useEffect, useState } from "react";
import {
    PaymentElement,
    useStripe,
    useElements
} from "@stripe/react-stripe-js";
import {showError, showMessage} from "../js/main";
import {Button} from "./form/Button";


export default function CheckoutForm() {
    const stripe = useStripe();
    const elements = useElements();

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!stripe) {
            return;
        }

        const clientSecret = new URLSearchParams(window.location.search).get(
            "payment_intent_client_secret"
        );

        if (!clientSecret) {
            return;
        }

        stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
            switch (paymentIntent.status) {
                case "succeeded":
                    showMessage("Zahlung erfolgreich!");
                    break;
                case "processing":
                    showMessage("Ihre Zahlung wird bearbeitet.");
                    break;
                case "requires_payment_method":
                    showError("Die Zahlung war nicht erfolgreich, bitte versuchen Sie es nochmals.");
                    break;
                default:
                    showError("Leider ist etwas schief gegangen.");
                    break;
            }
        });
    }, [stripe]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setIsLoading(true);

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: window.location.href + (window.location.href.endsWith("/") ? "" : "/") + "handleResponse",
            },
        });

        // This point will only be reached if there is an immediate error when
        // confirming the payment. Otherwise, your customer will be redirected to
        // your `return_url`. For some payment methods like iDEAL, your customer will
        // be redirected to an intermediate site first to authorize the payment, then
        // redirected to the `return_url`.
        if (error.type === "card_error" || error.type === "validation_error") {
            showError(error.message);
        } else {
            showError("Es ist ein Fehler aufgetreten.");
        }

        setIsLoading(false);
    };

    const paymentElementOptions = {
        layout: "tabs"
    }

    return (
        <form id="payment-form" onSubmit={handleSubmit}>
            <PaymentElement id="payment-element" options={paymentElementOptions} />
            <Button submitting={isLoading} disabled={isLoading || !stripe || !elements} id="submit" width={250}>Jetzt bezahlen</Button>
        </form>
    );
}